import {Pipe, PipeTransform} from '@angular/core';
import {iconToMaterialSymbol} from '../material-icons';

// Icon names from the backend are legacy icon-font classes (`icon-plus`) or
// Material Symbol names (`edit`). Returns the Material Symbol name, or
// undefined when there is no translation, so the caller can keep the old icon.
@Pipe({name: 'materialSymbol', standalone: true})
export class MaterialSymbolPipe implements PipeTransform {
  transform(icon: string | null | undefined): string | undefined {
    const iconClass = icon?.trim().split(/\s+/)[0];
    if (!iconClass) {
      return undefined;
    }
    const symbol = iconToMaterialSymbol(iconClass);
    return symbol?.startsWith('icon-') ? undefined : symbol;
  }
}
